import { CLEAN, ERROR_SERVER, GET_EQUIPMENTS, SET_ACCESS_EQUIPMENT, SET_ACCESS_EQUIPMENTS_SELECTED, } from "./types";

const AccessEquipmentReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case CLEAN:
            return {
                equipments: [],
                error: false,
                message: '',
                accessEquipmentsSelected: [],
                accessEquipment: {
                    equipmentTypeId: '',
                    description: '',
                }
            }
        case GET_EQUIPMENTS:
            return {
                ...state,
                equipments: payload,
                error: false,
                message: '',
            }
        case ERROR_SERVER:
            return {
                ...state,
                error: true,
                message: payload
            }
        case SET_ACCESS_EQUIPMENTS_SELECTED:
            return {
                ...state,
                accessEquipmentsSelected: payload,
            }
        case SET_ACCESS_EQUIPMENT:
            return {
                ...state,
                accessEquipment: payload
            }
        default:
            return state
    }
}

export default AccessEquipmentReducer